import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ExceptionManager } from "Core/logManager";
import { clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";

const INIT_STATE = {
  openResetPasswordDriver: false,
  driver: null,
  response: null,
  loading: false,
  error: null,
};

const route =
  "modules/driver/views/driverTable/components/resetPasswordDriver/redux/slices";

export const createDriverFSMAction = createAsyncThunk(
  `${route}/createDriverFSMAction`,

  async (payload, { rejectWithValue, dispatch }) => {
    const {
      driverId,
      username,
      password,
      defaultTab,
      hasVideoAccess
    } = payload;

    try {
      let data = await clientMutation(
        `
        mutation createDriverFSM (
            $driverId: Int!
            $username: String!
            $password: String!
            $defaultTab: String!
            $hasVideoAccess: Boolean
        ) {
            createDriverFSM (
                driverId: $driverId, 
                username: $username, 
                password: $password,
                defaultTab: $defaultTab,
                hasVideoAccess: $hasVideoAccess
            )
        }
        `,
        {
          driverId,
          username,
          password,
          defaultTab,
          hasVideoAccess,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );

      if (data) {
        return data?.createDriverFSM;
      } else {
        throw "Error while creating driver FSM";
      }
    } catch (exc) {
      ExceptionManager(exc, route, "createPasswordDriverAction");
      rejectWithValue(exc);
    }
  }
);

export const resetPasswordDriverAction = createAsyncThunk(
  `${route}/resetPasswordDriverAction`,

  async (payload, { rejectWithValue, dispatch }) => {
    const {
      driverId,
      username,
      password,
      hasVideoAccess
    } = payload;

    try {
      let data = await clientMutation(
        `
        mutation resetPasswordDriver (
            $driverId: Int!,
            $username: String!,
            $password: String!,
            $hasVideoAccess: Boolean
        ) {
            resetPasswordDriver (
                driverId: $driverId, 
                username: $username, 
                password: $password,
                hasVideoAccess: $hasVideoAccess
            )
        }
        `,
        {
          driverId,
          username,
          password,
          hasVideoAccess,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );

      if (data) {
        return data?.resetPasswordDriver;
      } else {
        throw "Error while resetting password";
      }
    } catch (exc) {
      ExceptionManager(exc, route, "resetPasswordDriverAction");
      rejectWithValue(exc);
    }
  }
);

export const resetPasswordDriverSliceRedux = createSlice({
  name: `${route}/resetPasswordDriver`,
  initialState: INIT_STATE,
  reducers: {
    openResetPasswordDriverModal: (state, action) => {
      return {
        ...state,
        openResetPasswordDriver: action.payload?.open,
        driver: action.payload?.driver,
        response: action.payload?.response
      };
    },
  },
  extraReducers: (builder) => {
    //resetPasswordDriverAction
    builder.addCase(resetPasswordDriverAction.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(resetPasswordDriverAction.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.response = true;
    });
    builder.addCase(resetPasswordDriverAction.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    //createDriverFSMAction
    builder.addCase(createDriverFSMAction.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(createDriverFSMAction.fulfilled, (state, { payload }) => {
      state.loading = false;  
      state.response = true;
    });
    builder.addCase(createDriverFSMAction.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });
  },
});

const { actions, reducer } = resetPasswordDriverSliceRedux;

export const { openResetPasswordDriverModal } = actions;

export default reducer;
